export default __webpack_public_path__ + "static/media/lifeIns2.bd08a692.jpg";